// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3423":"3b74f0fe","6256":"1bbb2128","7093":"fdddc5a8","7323":"1303556a"}[chunkId] + ".chunk.css";
};